import { O2_SKIN as o } from "./constants.js";
import { applyAlpha as r } from "../utils/color.js";
const e = {
    o2BluePrimary: "#0019A5",
    o2BluePrimary70: "#000066",
    o2BluePrimary90: "#000033",
    o2BluePrimary30: "#808CD2",
    o2BluePrimary15: "#CCD1ED",
    o2BluePrimary10: "#E5E8F6",
    o2BlueMid: "#0090D0",
    o2BlueLight: "#41B6E6",
    o2BlueLight30: "#C6E9F7",
    o2BlueLight35: "#8DD3F0",
    o2Teal: "#01B7B4",
    o2Green: "#91C90E",
    o2Green10: "#F4FAE7",
    o2Green40: "#B2D956",
    o2Green80: "#415A06",
    o2Yellow: "#FEDB00",
    o2Orange: "#FF7F41",
    o2Orange10: "#FFF2EC",
    o2Orange40: "#FFA57A",
    o2Orange75: "#A6522A",
    o2Pink: "#E45DBF",
    o2Purple: "#952D98",
    o2Purple10: "#F4EAF5",
    o2Purple30: "#CA9ACB",
    pepper: "#F4364C",
    pepper10: "#FEEBED",
    pepper20: "#FCC3C9",
    pepper40: "#FF7380",
    pepper60: "#C32B3D",
    grey1: "#F6F6F6",
    grey2: "#EEEEEE",
    grey3: "#DDDDDD",
    grey4: "#999999",
    grey5: "#707070",
    grey6: "#000033",
    white: "#FFFFFF",
    darkModeBlack: "#191919",
    darkModeGrey: "#242424",
    darkModeGrey6: "#313235",
    darkModeO2BluePrimary: "#0020D6",
    darkModeO2BluePrimaryDark: "#000099"
}, d = ()=>({
        name: o,
        colors: {
            background: e.white,
            backgroundAlternative: e.grey1,
            backgroundBrand: e.o2BluePrimary,
            backgroundBrandSecondary: e.o2BluePrimary,
            backgroundContainer: e.white,
            backgroundContainerHover: r(e.darkModeBlack, 0.03),
            backgroundContainerPressed: r(e.darkModeBlack, 0.05),
            backgroundContainerBrand: e.o2BluePrimary,
            backgroundContainerBrandHover: r(e.darkModeBlack, 0.2),
            backgroundContainerBrandPressed: r(e.darkModeBlack, 0.4),
            backgroundContainerBrandOverInverse: e.o2BluePrimary70,
            backgroundContainerAlternative: e.grey1,
            backgroundOverlay: r(e.grey6, 0.6),
            backgroundSkeleton: e.grey2,
            backgroundSkeletonInverse: e.o2BluePrimary70,
            backgroundFeedbackBottom: e.o2BluePrimary,
            appBarBackground: e.white,
            navigationBarBackground: e.o2BluePrimary,
            skeletonWave: e.grey2,
            borderLow: e.grey1,
            border: e.grey3,
            borderHigh: e.grey5,
            borderSelected: e.o2BluePrimary,
            coverBackgroundHover: r(e.darkModeBlack, 0.25),
            coverBackgroundPressed: r(e.darkModeBlack, 0.35),
            buttonDangerBackground: e.pepper,
            buttonDangerBackgroundSelected: e.pepper60,
            buttonDangerBackgroundHover: e.pepper60,
            buttonLinkBackgroundSelected: e.o2BluePrimary10,
            buttonLinkBackgroundInverseSelected: r(e.white, 0.08),
            buttonPrimaryBackground: e.o2BluePrimary,
            buttonPrimaryBackgroundInverse: e.white,
            buttonPrimaryBackgroundSelected: e.o2BluePrimary70,
            buttonPrimaryBackgroundHover: e.o2BluePrimary70,
            buttonPrimaryBackgroundInverseSelected: e.o2BluePrimary30,
            buttonSecondaryBorder: e.o2BluePrimary,
            buttonSecondaryBorderSelected: e.o2BluePrimary70,
            buttonSecondaryBackgroundHover: e.o2BluePrimary10,
            buttonSecondaryBackgroundSelected: e.o2BluePrimary10,
            buttonSecondaryBorderInverse: e.white,
            buttonSecondaryBorderInverseSelected: e.o2BluePrimary30,
            buttonSecondaryBackgroundInverseHover: r(e.white, 0.15),
            buttonSecondaryBackgroundInverseSelected: r(e.white, 0.15),
            textButtonPrimary: e.white,
            textButtonPrimaryInverse: e.o2BluePrimary,
            textButtonPrimaryInverseSelected: e.o2BluePrimary70,
            textButtonSecondary: e.o2BluePrimary,
            textButtonSecondarySelected: e.o2BluePrimary70,
            textButtonSecondaryInverse: e.white,
            textButtonSecondaryInverseSelected: e.white,
            textLink: e.o2BluePrimary,
            textLinkInverse: e.white,
            textLinkDanger: e.pepper,
            textLinkSnackbar: e.o2BluePrimary30,
            control: e.grey3,
            controlActivated: e.o2BluePrimary,
            controlError: e.pepper,
            loadingBar: e.o2BluePrimary,
            loadingBarBackground: e.grey1,
            toggleAndroidInactive: e.grey2,
            toggleAndroidBackgroundActive: e.o2BluePrimary15,
            iosControlKnob: e.white,
            divider: e.grey2,
            dividerInverse: r(e.white, 0.2),
            navigationBarDivider: e.o2BluePrimary,
            badge: e.pepper60,
            feedbackErrorBackground: e.pepper,
            feedbackInfoBackground: e.grey6,
            brand: e.o2BluePrimary,
            brandHigh: e.o2BluePrimary70,
            inverse: e.white,
            neutralHigh: e.grey6,
            neutralMedium: e.grey5,
            neutralMediumInverse: e.grey5,
            neutralLow: e.grey1,
            neutralLowAlternative: e.grey2,
            textPrimary: e.grey6,
            textPrimaryInverse: e.white,
            textSecondary: e.grey5,
            textSecondaryInverse: e.o2BluePrimary15,
            success: e.o2Green,
            warning: e.o2Orange,
            error: e.pepper,
            promo: e.o2Purple,
            highlight: e.o2Pink,
            successLow: e.o2Green10,
            warningLow: e.o2Orange10,
            errorLow: e.pepper10,
            promoLow: e.o2Purple10,
            brandLow: e.o2BluePrimary10,
            successHigh: e.o2Green80,
            warningHigh: e.o2Orange75,
            errorHigh: e.pepper60,
            promoHigh: e.o2Purple,
            successHighInverse: e.o2Green80,
            warningHighInverse: e.o2Orange75,
            errorHighInverse: e.pepper60,
            promoHighInverse: e.o2Purple,
            textNavigationBarPrimary: e.white,
            textNavigationBarSecondary: e.o2BluePrimary30,
            textNavigationSearchBarHint: e.o2BluePrimary30,
            textNavigationSearchBarText: e.white,
            textAppBar: e.grey4,
            textAppBarSelected: e.o2BluePrimary,
            customTabsBackground: e.o2BluePrimary
        },
        darkModeColors: {
            background: e.darkModeBlack,
            backgroundAlternative: e.darkModeBlack,
            backgroundBrand: e.darkModeBlack,
            backgroundBrandSecondary: e.darkModeBlack,
            backgroundContainer: e.darkModeGrey,
            backgroundContainerHover: r(e.white, 0.03),
            backgroundContainerPressed: r(e.white, 0.05),
            backgroundContainerBrand: e.darkModeGrey,
            backgroundContainerBrandHover: r(e.white, 0.03),
            backgroundContainerBrandPressed: r(e.white, 0.05),
            backgroundContainerBrandOverInverse: e.darkModeGrey,
            backgroundContainerAlternative: e.darkModeGrey,
            backgroundOverlay: r(e.darkModeGrey, 0.8),
            backgroundSkeleton: e.darkModeGrey6,
            backgroundSkeletonInverse: e.darkModeGrey6,
            backgroundFeedbackBottom: e.darkModeBlack,
            appBarBackground: e.darkModeGrey,
            navigationBarBackground: e.darkModeBlack,
            skeletonWave: e.grey5,
            borderLow: e.darkModeBlack,
            border: e.darkModeGrey,
            borderHigh: e.grey5,
            borderSelected: e.o2BluePrimary30,
            coverBackgroundHover: r(e.darkModeBlack, 0.25),
            coverBackgroundPressed: r(e.darkModeBlack, 0.35),
            buttonDangerBackground: e.pepper,
            buttonDangerBackgroundSelected: e.pepper60,
            buttonDangerBackgroundHover: e.pepper60,
            buttonLinkBackgroundSelected: r(e.white, 0.08),
            buttonLinkBackgroundInverseSelected: r(e.white, 0.08),
            buttonPrimaryBackground: e.darkModeO2BluePrimary,
            buttonPrimaryBackgroundInverse: e.darkModeO2BluePrimary,
            buttonPrimaryBackgroundSelected: e.darkModeO2BluePrimaryDark,
            buttonPrimaryBackgroundHover: e.darkModeO2BluePrimaryDark,
            buttonPrimaryBackgroundInverseSelected: e.darkModeO2BluePrimaryDark,
            buttonSecondaryBackgroundSelected: r(e.white, 0.15),
            buttonSecondaryBorder: e.white,
            buttonSecondaryBorderSelected: e.white,
            buttonSecondaryBorderInverse: e.white,
            buttonSecondaryBorderInverseSelected: e.white,
            buttonSecondaryBackgroundHover: r(e.white, 0.15),
            buttonSecondaryBackgroundInverseHover: r(e.white, 0.15),
            buttonSecondaryBackgroundInverseSelected: r(e.white, 0.15),
            textButtonPrimary: e.grey2,
            textButtonPrimaryInverse: e.grey2,
            textButtonPrimaryInverseSelected: e.grey2,
            textButtonSecondary: e.grey2,
            textButtonSecondarySelected: e.grey2,
            textButtonSecondaryInverse: e.grey2,
            textButtonSecondaryInverseSelected: e.grey2,
            textLink: e.o2BluePrimary30,
            textLinkInverse: e.o2BluePrimary30,
            textLinkDanger: e.pepper,
            textLinkSnackbar: e.o2BluePrimary30,
            control: e.darkModeGrey6,
            controlActivated: e.o2BluePrimary30,
            controlError: e.pepper,
            loadingBar: e.darkModeO2BluePrimary,
            loadingBarBackground: e.darkModeGrey6,
            toggleAndroidInactive: e.grey4,
            toggleAndroidBackgroundActive: e.o2BlueLight30,
            iosControlKnob: e.grey2,
            badge: e.pepper60,
            feedbackErrorBackground: e.pepper,
            feedbackInfoBackground: e.darkModeGrey6,
            divider: r(e.white, 0.05),
            dividerInverse: r(e.white, 0.05),
            navigationBarDivider: e.darkModeBlack,
            brand: e.o2BluePrimary30,
            brandHigh: r(e.white, 0.05),
            inverse: e.grey2,
            neutralHigh: e.grey2,
            neutralMedium: e.grey5,
            neutralMediumInverse: e.grey5,
            neutralLow: e.darkModeGrey6,
            neutralLowAlternative: e.darkModeGrey6,
            textPrimary: e.grey2,
            textPrimaryInverse: e.grey2,
            textSecondary: e.grey4,
            textSecondaryInverse: e.grey4,
            success: e.o2Green,
            warning: e.o2Orange,
            error: e.pepper,
            promo: e.o2Purple,
            highlight: e.o2Pink,
            successLow: e.darkModeGrey6,
            warningLow: e.darkModeGrey6,
            errorLow: e.darkModeGrey6,
            promoLow: e.darkModeGrey6,
            brandLow: e.darkModeGrey6,
            successHigh: e.o2Green40,
            warningHigh: e.o2Orange40,
            errorHigh: e.pepper40,
            promoHigh: e.o2Purple30,
            successHighInverse: e.o2Green80,
            warningHighInverse: e.o2Orange75,
            errorHighInverse: e.pepper60,
            promoHighInverse: e.o2Purple,
            textNavigationBarPrimary: e.grey2,
            textNavigationBarSecondary: e.grey4,
            textNavigationSearchBarHint: e.grey4,
            textNavigationSearchBarText: e.grey2,
            textAppBar: e.grey5,
            textAppBarSelected: e.grey2,
            customTabsBackground: e.darkModeBlack
        },
        borderRadii: {
            avatar: "50%",
            bar: "999px",
            button: "4px",
            checkbox: "2px",
            container: "8px",
            indicator: "999px",
            input: "8px",
            legacyDisplay: "16px",
            popup: "8px",
            sheet: "8px"
        },
        textPresets: {
            cardTitle: {
                weight: "regular"
            },
            button: {
                weight: "medium"
            },
            tabsLabel: {
                weight: "medium",
                size: {
                    mobile: 16,
                    desktop: 18
                },
                lineHeight: {
                    mobile: 24,
                    desktop: 24
                }
            },
            link: {
                weight: "medium"
            },
            title1: {
                weight: "medium"
            },
            title2: {
                weight: "light",
                size: {
                    mobile: 20,
                    desktop: 28
                },
                lineHeight: {
                    mobile: 24,
                    desktop: 32
                }
            },
            indicator: {
                weight: "medium"
            },
            navigationBar: {
                weight: "medium"
            },
            text5: {
                weight: "light"
            },
            text6: {
                weight: "light"
            },
            text7: {
                weight: "light"
            },
            text8: {
                weight: "light"
            },
            text9: {
                weight: "light"
            },
            text10: {
                weight: "light"
            }
        }
    });
export { d as getO2Skin, e as palette };
